<template>
  <div class="hzc-home-page">
    <div class="hzc-home-page-content">
      <div class="content-ul clearfix">
        <div class="coke-banner">
          <p class="p">
            黑色系 <span>实时价格</span> <em>{{ cokeTime }}</em>
          </p>
          <el-carousel
            height="160px"
            direction="vertical"
            :autoplay="true"
            indicator-position="none"
            :interval="5000"
          >
            <el-carousel-item v-for="(items, index) in cokeBanner" :key="index">
              <div
                class="banner-content-li"
                v-for="(item, i) in items"
                :key="i"
              >
                <p>{{ item.druidParamName }}</p>
                <span
                  :style="{
                    color:
                      item.floatPrice > 0
                        ? '#EA6535'
                        : item.floatPrice < 0
                        ? '#079F93'
                        : '#777777',
                  }"
                  >{{ item.price }}</span
                >
                <div>
                  <em
                    :style="{
                      color:
                        item.floatPrice > 0
                          ? '#EA6535'
                          : item.floatPrice < 0
                          ? '#079F93'
                          : '#777777',
                    }"
                    >{{
                      item.floatPrice > 0
                        ? `+${item.floatPrice}`
                        : item.floatPrice
                    }}</em
                  >
                  |
                  <em
                    :style="{
                      color:
                        item.floatPrice > 0
                          ? '#EA6535'
                          : item.floatPrice < 0
                          ? '#079F93'
                          : '#777777',
                    }"
                    >{{ item.floatRate }}</em
                  >
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="report">
          <ClassificationHeader
            class="head"
            :name="'黑色系专题报告'"
            :flag="false"
            :unit="false"
            :neibu="true"
            :url="'/blackSeries/twoPage/report'"
          ></ClassificationHeader>
          <div class="classification-content">
            <div
              class="classification-content-div price"
              v-for="item in blackList"
              :key="item.id"
              style="height: 35px;line-height: 35px;"
            >
              <i></i>
              <p @click="blackDownloadReport(item)">{{ item.fileTitle }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content-ul clearfix">
        <div class="coke-banner">
          <p class="p">
            化工系 <span>实时价格</span> <em>{{ huaTime }}</em>
          </p>
          <el-carousel
            height="160px"
            direction="vertical"
            :initial-index="0"
            :autoplay="false"
            indicator-position="none"
            :interval="5000"
          >
            <el-carousel-item v-for="(items, index) in huaBanner" :key="index">
              <div
                class="banner-content-li"
                v-for="(item, i) in items"
                :key="i"
              >
                <p>{{ item.druidParamName }}</p>
                <span
                  :style="{
                    color:
                      item.floatPrice > 0
                        ? '#EA6535'
                        : item.floatPrice < 0
                        ? '#079F93'
                        : '#777777',
                  }"
                  >{{ item.price || "--" }}</span
                >
                <div>
                  <em
                    :style="{
                      color:
                        item.floatPrice > 0
                          ? '#EA6535'
                          : item.floatPrice < 0
                          ? '#079F93'
                          : '#777777',
                    }"
                    >{{
                      item.floatPrice > 0
                        ? `+${item.floatPrice}`
                        : item.floatPrice
                    }}</em
                  >
                  |
                  <em
                    :style="{
                      color:
                        item.floatPrice > 0
                          ? '#EA6535'
                          : item.floatPrice < 0
                          ? '#079F93'
                          : '#777777',
                    }"
                    >{{ item.floatRate }}</em
                  >
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="report">
          <ClassificationHeader
            class="head"
            :name="'化工系专题报告'"
            :flag="false"
            :unit="false"
            :neibu="true"
            :url="'/chemicalSeries/twoPage/report'"
          ></ClassificationHeader>
          <div class="classification-content">
            <div
              class="classification-content-div price"
              v-for="item in chemicalList"
              :key="item.id"
              style="height: 35px;line-height: 35px;"
            >
              <i></i>
              <p @click="chemicalDownloadReport(item)">{{ item.fileTitle }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content-ul clearfix">
        <ul>
          <li>
            <ClassificationHeader
              class="head"
              :name="'煤炭频道'"
              :flag="false"
              :unit="false"
              :url="'/coal'"
            ></ClassificationHeader>
            <span
              class="classification-tabs-three"
              @mouseover="coalFlag = 1"
              @click="toTwoPage('/coal/twoPage/enterprise')"
              :class="{ redFlag: coalFlag === 1 }"
              >重点企业资讯</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="coalFlag = 2"
              @click="
                toTwoPage('/coal/twoPage/price', 'issue_coal_place_price')
              "
              :class="{ redFlag: coalFlag === 2 }"
              >焦煤产地价格</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="coalFlag = 3"
              @click="toTwoPage('/coal/twoPage/rate')"
              :class="{ redFlag: coalFlag === 3 }"
              >煤矿开工率</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="coalFlag = 4"
              @click="toTwoPage('/coal/twoPage/report', 2)"
              :class="{ redFlag: coalFlag === 4 }"
              >研究报告</span
            >
            <div class="classification-content" v-if="coalFlag === 1">
              <div
                class="classification-content-div price"
                v-for="(item, index) in coalOne"
                :key="index"
              >
                <i></i>
                <p @click="goDetail('/coal/enterprise', item.collectionTime)">
                  {{ item.showTimeword + "煤炭重点企业资讯 " }}
                </p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="coalFlag === 2">
              <div
                class="classification-content-div price"
                v-for="(item, index) in coalTwo"
                :key="index"
              >
                <i></i>
                <p
                  @click="
                    goDetail(
                      '/coal/priceIndex',
                      item.completeOriginalDate,
                      'issue_coal_place_price'
                    )
                  "
                >
                  {{ item.date + "焦煤产地价格" }}
                </p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="coalFlag === 3">
              <div
                class="classification-content-div price"
                v-for="(item, index) in coalThree"
                :key="index"
              >
                <i></i>
                <p
                  @click="
                    goDetail(
                      '/coal/operatingRate',
                      item.completeOriginalDate,
                      'manual_entry_show_coal_rate'
                    )
                  "
                >
                  {{ item.date + "煤矿开工率" }}
                </p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="coalFlag === 4">
              <div
                class="classification-content-div price"
                v-for="(item, index) in coalFour"
                :key="index"
              >
                <i></i>
                <p @click="coalDownloadReport(item)" style="width: 200px">
                  {{ item.fileTitle }}
                </p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </li>
          <li>
            <ClassificationHeader
              class="head"
              :name="'焦炭频道'"
              :flag="false"
              :unit="false"
              :url="'/coke'"
            ></ClassificationHeader>
            <span
              class="classification-tabs-three"
              @mouseover="cokeFlag = 1"
              @click="toTwoPage('/coke/twoPage/enterprise')"
              :class="{ redFlag: cokeFlag === 1 }"
              >重点企业资讯</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="cokeFlag = 2"
              @click="
                toTwoPage('/coke/twoPage/price', 'issue_coke_place_price')
              "
              :class="{ redFlag: cokeFlag === 2 }"
              >产地价格</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="cokeFlag = 3"
              @click="goDetail('/coke/enterpriseCapacity')"
              :class="{ redFlag: cokeFlag === 3 }"
              >焦化产能一览</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="cokeFlag = 4"
              @click="toTwoPage('/coke/twoPage/report', 2)"
              :class="{ redFlag: cokeFlag === 4 }"
              >研究报告</span
            >
            <div class="classification-content" v-if="cokeFlag === 1">
              <div
                class="classification-content-div price"
                v-for="(item, index) in cokeOne"
                :key="index"
              >
                <i></i>
                <p @click="goDetail('/coke/enterprise', item.collectionTime)">
                  {{ item.showTimeword + "焦炭重点企业资讯" }}
                </p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="cokeFlag === 2">
              <div
                class="classification-content-div price"
                v-for="(item, index) in cokeTwo"
                :key="index"
              >
                <i></i>
                <p
                  @click="
                    goDetail(
                      '/coke/priceIndex',
                      item.completeOriginalDate,
                      'issue_coke_place_price'
                    )
                  "
                >
                  {{ item.date + "焦炭产地价格" }}
                </p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-show="cokeFlag === 3">
              <div
                class="classification-content"
                @click="goDetail('/coke/enterpriseCapacity')"
                style="cursor: pointer"
              >
                <div
                  id="myChartCapacity"
                  style="width: 372px; height: 240px; cursor: pointer"
                ></div>
              </div>
            </div>
            <div class="classification-content" v-if="cokeFlag === 4">
              <div
                class="classification-content-div price"
                v-for="(item, index) in cokeFour"
                :key="index"
              >
                <i></i>
                <p @click="cokeDownloadReport(item)" style="width: 200px">
                  {{ item.fileTitle }}
                </p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </li>
          <li>
            <ClassificationHeader
              class="head"
              :name="'钢铁频道'"
              :flag="false"
              :unit="false"
              :url="'/steel'"
            ></ClassificationHeader>
            <span
              class="classification-tabs-three"
              @mouseover="steelFlag = 1"
              @click="toTwoPage('/steel/twoPage/enterprise')"
              :class="{ redFlag: steelFlag === 1 }"
              >重点企业资讯</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="steelFlag = 2"
              @click="
                toTwoPage('/steel/twoPage/price', 'issue_steel_thread_price')
              "
              :class="{ redFlag: steelFlag === 2 }"
              >螺纹价格</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="steelFlag = 3"
              style="
                font-size: 12px;
                height: 36px;
                padding: 0 20px;
                width: 52.5px;
                line-height: revert;
              "
              @click="
                toTwoPage(
                  '/steel/twoPage/yield',
                  'issue_steel_varieties_yield',
                  2
                )
              "
              :class="{ redFlag: steelFlag === 3 }"
              >五大品种合计产量</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="steelFlag = 4"
              @click="toTwoPage('/steel/twoPage/report', 2)"
              :class="{ redFlag: steelFlag === 4 }"
              >研究报告</span
            >
            <div class="classification-content" v-if="steelFlag === 1">
              <div
                class="classification-content-div price"
                v-for="(item, index) in steelOne"
                :key="index"
              >
                <i></i>
                <p @click="goDetail('/steel/enterprise', item.collection_time)">
                  {{ item.showTimeword + "钢铁重点企业资讯" }}
                </p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="steelFlag === 2">
              <div
                class="classification-content-div price"
                v-for="(item, index) in steelTwo"
                :key="index"
              >
                <i></i>
                <p
                  @click="
                    goDetail(
                      '/steel/price',
                      item.completeOriginalDate,
                      'issue_steel_thread_price'
                    )
                  "
                >
                  {{ item.date + "螺纹价格" }}
                </p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="steelFlag === 3">
              <div
                class="classification-content-div price"
                v-for="(item, index) in steelThree"
                :key="index"
              >
                <i></i>
                <p
                  @click="
                    goDetail(
                      '/steel/yield',
                      item.completeOriginalDate,
                      'issue_steel_varieties_yield'
                    )
                  "
                >
                  {{ item.date + "五大品种合计产量" }}
                </p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="steelFlag === 4">
              <div
                class="classification-content-div price"
                v-for="(item, index) in steelFour"
                :key="index"
              >
                <i></i>
                <p @click="steelDownloadReport(item)" style="width: 200px">
                  {{ item.fileTitle }}
                </p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </li>
          <li>
            <ClassificationHeader
              class="head"
              :name="'芳烃频道'"
              :flag="false"
              :unit="false"
              :url="'/oilBenzene'"
            ></ClassificationHeader>
            <span
              class="classification-tabs-three"
              @mouseover="oilBenzeneFlag = 1"
              @click="toTwoPage('/oilBenzene/twoPage/enterprise')"
              :class="{ redFlag: oilBenzeneFlag === 1 }"
              >重点企业资讯</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="oilBenzeneFlag = 2"
              @click="toTwoPage('/oilBenzene/twoPage/price', 1)"
              style="
                font-size: 12px;
                height: 36px;
                padding: 0 10px;
                width: 72.5px;
                line-height: revert;
              "
              :class="{ redFlag: oilBenzeneFlag === 2 }"
              >石油苯中石化挂牌价</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="oilBenzeneFlag = 3"
              @click="goDetail('/oilBenzene/map')"
              :class="{ redFlag: oilBenzeneFlag === 3 }"
              >企业分布地图</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="oilBenzeneFlag = 4"
              @click="toTwoPage('/oilBenzene/twoPage/report', 2)"
              :class="{ redFlag: oilBenzeneFlag === 4 }"
              >研究报告</span
            >
            <div class="classification-content" v-if="oilBenzeneFlag === 1">
              <div
                class="classification-content-div price"
                v-for="(item, index) in oilBenzeneOne"
                :key="index"
              >
                <i></i>
                <p
                  @click="
                    goDetail('/oilBenzene/enterprise', item.collectionTime)
                  "
                >
                  {{ item.showYearTime + "化工重点企业资讯" }}
                </p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="oilBenzeneFlag === 2">
              <div
                class="classification-content-div price"
                v-for="(item, index) in oilBenzeneTwo"
                :key="index"
              >
                <i></i>
                <p
                  @click="
                    goDetail('/oilBenzene/price', item.completeOriginalDate, 1)
                  "
                >
                  {{ item.date + "中石化石油苯挂牌价格" }}
                </p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="oilBenzeneFlag === 3">
              <img
                style="cursor: pointer"
                src="../../assets/home/map.png"
                @click="goDetail('/oilBenzene/map')"
                alt=""
              />
            </div>
            <div class="classification-content" v-if="oilBenzeneFlag === 4">
              <div
                class="classification-content-div price"
                v-for="(item, index) in oilBenzeneThree"
                :key="index"
              >
                <i></i>
                <p @click="aromaticsDownloadReport(item)" style="width: 200px">
                  {{ item.fileTitle }}
                </p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </li>
          <li>
            <ClassificationHeader
              class="head"
              :name="'醇氨频道'"
              :flag="false"
              :unit="false"
              :url="'/methanol'"
            ></ClassificationHeader>
            <span
              class="classification-tabs-three"
              @mouseover="methanolFlag = 1"
              @click="toTwoPage('/methanol/twoPage/price')"
              :class="{ redFlag: methanolFlag === 1 }"
              >价格</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="methanolFlag = 2"
              @click="toTwoPage('/methanol/twoPage/yield', 1)"
              :class="{ redFlag: methanolFlag === 2 }"
              >产量</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="methanolFlag = 3"
              @click="goDetail('/methanol/map')"
              :class="{ redFlag: methanolFlag === 3 }"
              >企业分布地图</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="methanolFlag = 4"
              @click="toTwoPage('/methanol/twoPage/report', 2)"
              :class="{ redFlag: methanolFlag === 4 }"
              >研究报告</span
            >
            <div class="classification-content" v-if="methanolFlag === 1">
              <div
                class="classification-content-div price"
                v-for="(item, index) in methanolOne"
                :key="index"
              >
                <i></i>
                <p
                  style="
                    width: 200px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  "
                  @click="
                    goDetail('/methanol/price', item.completeOriginalDate)
                  "
                >
                  {{ item.date + "甲醇价格" }}
                </p>
                <span class="fr" style="color: #777777; font-size: 12px">{{
                  item.originalDate
                }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="methanolFlag === 2">
              <div
                class="classification-content-div price"
                v-for="(item, index) in methanolTwo"
                :key="index"
              >
                <i></i>
                <p
                  @click="
                    goDetail('/methanol/yield', item.completeOriginalDate)
                  "
                >
                  {{ item.date + "甲醇全国周产量" }}
                </p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="methanolFlag === 3">
              <img
                style="cursor: pointer"
                src="../../assets/home/map.png"
                @click="goDetail('/methanol/map')"
                alt=""
              />
            </div>
            <div class="classification-content" v-if="methanolFlag === 4">
              <div
                class="classification-content-div price"
                v-for="(item, index) in methanolThree"
                :key="index"
              >
                <i></i>
                <p @click="methanolDownloadReport(item)" style="width: 200px">
                  {{ item.fileTitle }}
                </p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </li>
          <li>
            <ClassificationHeader
              class="head"
              :name="'碳材料频道'"
              :flag="false"
              :unit="false"
              :url="'/zetar'"
            ></ClassificationHeader>
            <span
              class="classification-tabs-three"
              @mouseover="materialFlag = 1"
              @click="
                toTwoPage(
                  '/zetar/twoPage/price',
                  'issue_material_add_area_price'
                )
              "
              style="
                font-size: 12px;
                height: 36px;
                padding: 0 10px;
                width: 72.5px;
                line-height: revert;
              "
              :class="{ redFlag: materialFlag === 1 }"
              >煤焦油区域价格</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="materialFlag = 2"
              @click="toTwoPage('/zetar/twoPage/rate')"
              :class="{ redFlag: materialFlag === 2 }"
              >深加工开工率</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="materialFlag = 3"
              @click="goDetail('/zetar/map')"
              :class="{ redFlag: materialFlag === 3 }"
              >企业分布地图</span
            >
            <span
              class="classification-tabs-three"
              @mouseover="materialFlag = 4"
              @click="toTwoPage('/zetar/twoPage/report', 2)"
              :class="{ redFlag: materialFlag === 4 }"
              >研究报告</span
            >
            <div class="classification-content" v-if="materialFlag === 1">
              <div
                class="classification-content-div price"
                v-for="(item, index) in materialOne"
                :key="index"
              >
                <i></i>
                <p
                  style="
                    width: 200px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  "
                  @click="
                    goDetail(
                      '/zetar/price',
                      item.completeOriginalDate,
                      'issue_material_add_area_price'
                    )
                  "
                >
                  {{ item.date + "煤焦油区域价格" }}
                </p>
                <span class="fr" style="color: #777777; font-size: 12px">{{
                  item.originalDate
                }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="materialFlag === 2">
              <div
                class="classification-content-div price"
                v-for="(item, index) in materialTwo"
                :key="index"
              >
                <i></i>
                <p @click="goDetail('/zetar/rate', item.completeOriginalDate)">
                  {{ item.date + "煤焦油开工率" }}
                </p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="materialFlag === 3">
              <img
                style="cursor: pointer"
                src="../../assets/home/map.png"
                @click="goDetail('/zetar/map')"
                alt=""
              />
            </div>
            <div class="classification-content" v-if="materialFlag === 4">
              <div
                class="classification-content-div price"
                v-for="(item, index) in materialThree"
                :key="index"
              >
                <i></i>
                <p @click="zetarDownloadReport(item)" style="width: 200px">
                  {{ item.fileTitle }}
                </p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <img
        src="../../assets/home/indexBanner.png"
        style="width: 1200px; margin-bottom: 24px"
        alt=""
      />
      <div class="about">
        <div class="left">
          <div class="title">
            <em></em>
            <span>关于网站</span>
          </div>
          <div class="content">
            商品研究大数据汇聚旭阳集团重点关注商品的市场行业数据，实现用户对市场资讯、分析经验的共享共用。积累沉淀数据及规律，精准掌握市场动态，分析行情趋势，辅助经营决策。
          </div>
        </div>
        <div class="right">
          <img src="../../assets/home/indexLogo.png" alt="" />
          <p>商品研究大数据</p>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="link">
        <span>友情链接：</span>
        <em @click="goLink('http://www.risun.com')">旭阳集团</em>
        <em @click="goLink('http://emall.risuncloud.com/#/')">旭阳电子商城</em>
        <em @click="goLink('https://dip.risun.com/')">数智工作台</em>
      </div>
      <div class="footer-content">
        <div class="container">
          <ul>
            <li>
              <p>快速导航</p>
              <span style="cursor: pointer" @click="goRouter('/macroscopic')"
                >宏观政策</span
              >
              <span style="cursor: pointer" @click="goRouter('/coke')"
                >焦炭市场</span
              >
              <span style="cursor: pointer" @click="goRouter('/coal')"
                >煤炭行情</span
              >
              <span style="cursor: pointer" @click="goRouter('/steel')"
                >钢铁数据</span
              >
            </li>
            <li style="width: 360px">
              <p>频道维护</p>
              <span>煤炭频道编辑：杨澜</span>
              <span>醇氨频道编辑：王帅</span>
              <span>焦炭频道编辑：柳建伟</span>
              <span>碳材料频道编辑：靳婷</span>
              <span>钢铁频道编辑：孙岩</span>
              <span>石油频道编辑：付书研</span>
              <span>芳烃频道编辑：吴云蕊</span>
              <span>氢能频道编辑：罗宁川</span>
            </li>
            <li>
              <p>关于我们</p>
              <span
                style="cursor: pointer"
                @click="goLink('http://www.risun.com')"
                >旭阳集团</span
              >
              <span style="cursor: pointer">版本记录</span>
              <span style="cursor: pointer">意见反馈</span>
            </li>
            <li>
              <p>咨询热线</p>
              <em>010-63701616</em>
              <p>服务时间</p>
              <span>周一至周五</span>
              <span>08:00-17:00</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="end">
        <p>维护单位：旭阳集团市场管理部</p>
        <p>
          本网站数据仅限旭阳内部使用，不得转载，不得对外提供。维护单位保留任何侵权行为追究的权利。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ClassificationHeader from "@/components/common/ClassificationHeader";
import {
  examineNoAuthList,
  priceNoAuthList,
  cokeReportDetail,
  reportNoAuthList,
  getNoAuthCompanyCoke,
} from "@/api/coke";
import {
  coalExamineNoAuthList,
  coalPlaceList,
  coalRateNoAuthList,
  coalReportDetail,
  coalReportNoAuthList,
} from "@/api/coal";
import {
  steelExamineNoAuthList,
  steelPriceNoAuthList,
  steelReportDetail,
  steelReportNoAuthList,
  steelYieldNoAuthList,
} from "@/api/steel";
import {
  oilBenzeneExamineNoAuthList,
  oilBenzenePriceNoAuthList,
  oilBenzeneReportDetail,
  oilBenzeneReportNoAuthList,
} from "@/api/oilBenzene";
import {
  methanolPriceNoAuthList,
  methanolReportDetail,
  methanolYieldNoAuthList,
  noAuthReportAndStandard,
} from "@/api/methanol";
import Expect from "@/components/common/expect";
import { indexList, getTokenLogin } from "@/api";
import {
  rateNoAuthList,
  zetarPriceNoAuthList,
  zetarReportDetail,
  zetarReportNoAuthList,
} from "@/api/zetar";
import { 
  getBlackReport,
  getChemicalReport
} from "@/api/other";
import { arrayPages } from "@/utils/ruoyi";
import { Message } from "element-ui";

export default {
  name: "index",
  components: {
    ClassificationHeader,
    Expect,
  },
  data() {
    return {
      // banner
      cokeBanner: [],
      cokeSize: 5,
      cokeTime: "",
      huaBanner: [],
      huaSize: 5,
      huaTime: "",
      // 黑色系专题报告
      blackList: [],
      // 化工系专题报告
      chemicalList: [],
      // 煤炭
      coalFlag: 1,
      coalOne: [],
      coalTwo: [],
      coalThree: [],
      coalFour: [],
      // 焦炭
      cokeFlag: 1,
      cokeOne: [],
      cokeTwo: [],
      cokeThree: [],
      cokeFour: [],
      optionCapacity: {
        title: {
          // text: "ECharts 入门示例"
        },
        tooltip: {},
        xAxis: {
          data: [],
        },
        yAxis: {},
        series: [
          {
            data: [],
            type: "bar",
            barWidth: 20, //柱图宽度
            itemStyle: {
              normal: {
                color: "#F26D77",
              },
            },
          },
        ],
        grid: {
          x: 60,
          y: 25,
          x2: 10,
          y2: 50,
        },
      },
      // 钢铁
      steelFlag: 1,
      steelOne: [],
      steelTwo: [],
      steelThree: [],
      steelFour: [],
      // 芳烃
      oilBenzeneFlag: 1,
      oilBenzeneOne: [],
      oilBenzeneTwo: [],
      oilBenzeneThree: [],
      // 甲醇
      methanolFlag: 1,
      methanolOne: [],
      methanolTwo: [],
      methanolThree: [],
      // 碳材料
      materialFlag: 1,
      materialOne: [],
      materialTwo: [],
      materialThree: [],
    };
  },
  created() {
    if (this.$route.query && this.$route.query.tokenFlag === "1") {
      Message({
        message: "暂无权限进入页面，请联系管理员开通权限",
        type: "error",
      });
    }
    this.getHomeList();
  },
  mounted() {
    this.$nextTick(() => {
      // 企业产能
      getNoAuthCompanyCoke().then((res) => {
        this.optionCapacity["xAxis"]["data"] = res.data["areaList"];
        this.optionCapacity["series"][0]["data"] = res.data["priceSumList"];
        this.drawChart();
      });
    });
  },
  methods: {
    /**
     * 获取首页信息
     */
    getHomeList() {
      // 首页轮播图
      indexList({ dictDataType: "issue_real_time_coke_steel" }).then((res) => {
        this.cokeBanner = arrayPages(res.data.data, this.cokeSize);
        this.cokeTime = res.data.titleList[0];
      });
      indexList({ dictDataType: "issue_real_time_chemical" }).then((res) => {
        this.huaBanner = arrayPages(res.data.data, this.huaSize);
        this.huaTime = res.data.titleList[0];
      });
      // 黑色系专题报告
      reportNoAuthList({
        pageNum: 1,
        pageSize: 5,
        fileType: 12,
      }).then((res) => {
        this.blackList = res.rows;
      });
      // 化工系专题报告
      reportNoAuthList({
        pageNum: 1,
        pageSize: 5,
        fileType: 13,
      }).then((res) => {
        this.chemicalList = res.rows;
      });
      // 煤炭重点企业
      coalExamineNoAuthList({ pageNum: 1, pageSize: 7 }).then((res) => {
        this.coalOne = res.rows;
      });
      // 煤炭产地价格
      coalPlaceList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_place_price",
        dataType: 1,
      }).then((res) => {
        this.coalTwo = res.rows;
      });
      // 煤炭开工率
      coalRateNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "manual_entry_show_coal_rate",
      }).then((res) => {
        this.coalThree = res.rows;
      });
      // 煤炭研究报告
      coalReportNoAuthList({
        pageNum: 1,
        pageSize: 7,
        sourceType: 3,
        fileType: 2,
      }).then((res) => {
        this.coalFour = res.rows;
      });
      // ---------------------------------——————————————————————————————————————————
      // 焦炭重点企业
      examineNoAuthList({ pageNum: 1, pageSize: 7 }).then((res) => {
        this.cokeOne = res.rows;
      });
      // 焦炭产地价格
      priceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coke_port_price",
        dataType: 1,
      }).then((res) => {
        this.cokeTwo = res.rows;
      });
      // 焦炭研究报告
      reportNoAuthList({
        pageNum: 1,
        pageSize: 7,
        sourceType: 1,
        fileType: 2,
      }).then((res) => {
        this.cokeFour = res.rows;
      });
      // ---------------------------------——————————————————————————————————————————
      // 钢铁重点企业
      steelExamineNoAuthList({ pageNum: 1, pageSize: 7 }).then((res) => {
        this.steelOne = res.rows;
      });
      // 钢铁产地价格
      steelPriceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_steel_thread_price",
        dataType: 1,
      }).then((res) => {
        this.steelTwo = res.rows;
      });
      // 钢铁产量
      steelYieldNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_steel_varieties_yield",
        dataType: 2,
      }).then((res) => {
        this.steelThree = res.rows;
      });
      // 钢铁研究报告
      steelReportNoAuthList({
        pageNum: 1,
        pageSize: 7,
        sourceType: 2,
        fileType: 2,
      }).then((res) => {
        this.steelFour = res.rows;
      });
      // ---------------------------------——————————————————————————————————————————默认石油苯
      // 芳烃重点企业
      oilBenzeneExamineNoAuthList({ pageNum: 1, pageSize: 7 }).then((res) => {
        this.oilBenzeneOne = res.rows;
      });
      // 芳烃产地价格
      oilBenzenePriceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "manual_entry_styrene_price",
      }).then((res) => {
        this.oilBenzeneTwo = res.rows;
      });
      // 芳烃研究报告
      oilBenzeneReportNoAuthList({
        pageNum: 1,
        pageSize: 7,
        sourceType: 9,
        fileType: 2,
      }).then((res) => {
        this.oilBenzeneThree = res.rows;
      });
      // ---------------------------------——————————————————————————————————————————默认甲醇
      // 醇胺价格
      methanolPriceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_methanol_price",
        dataType: 1,
      }).then((res) => {
        this.methanolOne = res.rows;
      });
      // 醇胺产量
      methanolYieldNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_methanol_yield",
        dataType: 2,
      }).then((res) => {
        this.methanolTwo = res.rows;
      });
      // 醇胺研究报告
      noAuthReportAndStandard({
        pageNum: 1,
        pageSize: 7,
        sourceType: 8,
        fileType: 2,
      }).then((res) => {
        this.methanolThree = res.rows;
      });
      // ---------------------------------——————————————————————————————————————————默认煤焦油
      // 价格指数
      zetarPriceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_material_add_area_price",
      }).then((res) => {
        this.materialOne = res.rows;
      });
      // 开工率
      rateNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coal_add_rate",
      }).then((res) => {
        this.materialTwo = res.rows;
      });
      zetarReportNoAuthList({
        pageNum: 1,
        pageSize: 7,
        sourceType: 6,
        fileType: 2,
      }).then((res) => {
        this.materialThree = res.rows;
      });
    },
    /**
     * 地图配置加载
     */
    drawChart() {
      let myChartCapacity = this.$echarts.init(
        document.getElementById("myChartCapacity")
      );
      myChartCapacity.setOption(this.optionCapacity);
    },
    /**
     * 外链
     */
    goLink(url) {
      window.openUrl(url);
    },
    /**
     * 内链
     */
    goRouter(url) {
      this.$router.push(url);
    },
    /**
     * 下载文件
     */
    blackDownloadReport(row) {
      getBlackReport(row['id'] + "/1").then((res) => {
        this.$setMenuInfoPath(['首页', '黑色系专题报告', '正文'], row['id']);
      })
    },
    chemicalDownloadReport(row) {
      getChemicalReport(row['id'] + "/1").then((res) => {
        this.$setMenuInfoPath(['首页', '化工系专题报告', '正文'], row['id']);
      })
    },
    coalDownloadReport(row) {
      coalReportDetail(row["id"] + "/1").then((res) => {
        this.$setMenuInfoPath(['焦煤', '研究报告', '正文'], row['id']);
      });
    },
    cokeDownloadReport(row) {
      cokeReportDetail(row["id"] + "/1").then((res) => {
        this.$setMenuInfoPath(['焦炭', '研究报告', '正文'], row['id']);
      });
    },
    steelDownloadReport(row) {
      steelReportDetail(row["id"] + "/1").then((res) => {
        this.$setMenuInfoPath(['钢铁', '研究报告', '正文'], row['id']);
      });
    },
    aromaticsDownloadReport(row) {
      oilBenzeneReportDetail(row["id"] + "/1").then((res) => {
        this.$setMenuInfoPath(['石油苯', '研究报告', '正文'], row['id']);
      });
    },
    methanolDownloadReport(row) {
      methanolReportDetail(row["id"] + "/1").then((res) => {
        this.$setMenuInfoPath(['甲醇', '研究报告', '正文'], row['id']);
      });
    },
    zetarDownloadReport(row) {
      zetarReportDetail(row["id"] + "/1").then((res) => {
        this.$setMenuInfoPath(['煤焦油加工', '研究报告', '正文'], row['id']);
      });
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag) {
      this.$router.push({ path: url, query: { flag } });
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag, other) {
      this.$router.push({
        path: `${url}`,
        query: { id: id, flag: flag, other: other },
      });
    },
  },
};
</script>

<style scoped lang="less">
.hzc-home-page-content {
  width: 1200px;
  margin: 0 auto;

  .coke-banner {
    float: left;
    width: 774px;
    height: 188px;
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
    padding: 16px 10px 20px 10px;
    box-sizing: border-box;
    .p {
      margin-bottom: 8px;
      //width: 80px;
      height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #222222;
      line-height: 28px;
      padding-left: 10px;
      span {
        width: 52px;
        height: 20px;
        background: linear-gradient(134deg, #f7c238 0%, #f71019 100%);
        border-radius: 6px 6px 6px 0px;
        padding: 3px;
        font-size: 12px;
        color: #fff;
        font-family: YouSheBiaoTiHei;
        line-height: 20px;
        vertical-align: middle;
        margin-left: 7px;
      }

      em {
        font-style: normal;
        font-size: 12px;
        width: 68px;
        height: 17px;
        color: #d3131a;
        line-height: 17px;
      }
    }
  }
}

.el-carousel__item .banner-content-li {
  width: 20%;
  display: inline-block;
  padding-top: 18px;
  text-align: center;

  p {
    margin: 0 auto;
    padding: 0 6px;
    //min-height: 20px;
    height: 40px;
    font-size: 14px;
    font-weight: 400;
    color: #222222;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /* autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    -webkit-line-clamp: 2;
    word-wrap: break-word;
    word-break: break-all;
  }

  span {
    width: 58px;
    height: 43px;
    font-size: 24px;
    font-weight: 500;
    display: inline-block;
    margin-top: 15px;
    color: #ea6535;
    width: 100%;
    border-right: 1px solid #cccccc;
  }

  div {
    color: #ea6535;
    margin-top: 10px;

    em {
      font-style: normal;
      font-size: 12px;
      color: #ea6535;
    }
  }

  .originColor {
    color: #ea6535;
  }

  .greenColor {
    color: #079f93;
  }
  &:last-child {
    span {
      border-right: none;
    }
  }
}

.content-ul {
  width: 1200px;
  margin: 0 0 24px 0;
  .report {
    float: left;
    margin-left: 15px;
    padding: 0 10px;
    width: 370px;
    height: 224px;
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
  }
  .classification-content {
    padding: 5px 0 0;

    .classification-content-div {
      height: 33px;
      line-height: 33px;

      i {
        width: 4px;
        height: 4px;
        background: #9b857b;
        display: inline-block;
        margin-right: 5px;
        border-radius: 50%;
      }

      p {
        max-width: 250px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        // 透明border
        border-style: solid;
        border-width: 1px;
        border-color: transparent;
      }

      p:hover {
        color: #d3131a;
        //border-bottom: 1px solid #D3131A;
        text-decoration: underline;
      }

      span {
        color: #777777;
        font-size: 12px;
      }
    }

    .price {
      height: 33px;
      line-height: 33px;

      img {
        width: 8px;
        margin-right: 5px;
      }
    }

    .map {
      height: 32px;
      line-height: 32px;
    }
  }
  li {
    float: left;
    width: 370px;
    padding: 0 10px;
    margin-right: 15px;
    height: 322px;
    background: #ffffff;
    margin-bottom: 20px;
    box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);

    img {
      width: 372px;
      height: 226px;
    }

    .head {
      color: #222222;
      height: 35px;
      font-size: 18px;
      line-height: 30px;
      position: relative;
      border-bottom: 2px solid #ccc;
      padding: 10px 0 0;

      .red-title {
        width: 168px;
        height: 36px;
        background: #d3131a;
        border-radius: 4px 4px 0px 0px;
        color: #fff;
        text-align: center;
        line-height: 36px;
      }

      i {
        width: 60px;
        height: 2px;
        background: #cccccc;
        display: inline-block;
        position: absolute;
        bottom: 0;
      }

      em {
        width: 4px;
        height: 18px;
        background: #d3131a;
        font-style: normal;
        display: inline-block;
        margin: 16px 4px 6px 16px;
        vertical-align: middle;
      }

      img {
        width: 44px;
        vertical-align: middle;
        margin-right: 9px;
      }

      p {
        font-size: 18px;
        display: inline-block;
        vertical-align: middle;
        margin-top: 10px !important;
      }

      span {
        font-size: 12px;
        cursor: pointer;
        height: 20px;
        border-bottom: 1px solid #fff;
        position: absolute;
        right: 0;
        top: 2px;
      }

      span:hover {
        border-bottom: 1px solid #222;
      }
    }

    .classification-tabs-two {
      width: 123px;
      height: 34px;
      line-height: 34px;
      display: inline-block;
      background: #f2f2f2;
      border-top: 2px solid #f2f2f2;
      color: #222;
      text-align: center;
      cursor: pointer;
    }

    .priceFlag {
      border-top: 2px solid #d3131a;
      background-color: #fff;
    }

    .classification-tabs-two:hover {
      border-top: 2px solid #d3131a;
      background-color: #fff;
    }

    .classification-tabs-three {
      width: 92.5px;
      height: 36px;
      line-height: 34px;
      display: inline-block;
      background: #f2f2f2;
      color: #222;
      text-align: center;
      cursor: pointer;
      vertical-align: middle;
    }

    .redFlag {
      background-color: #d3131a;
      color: #fff;
    }

    .classification-tabs-three:hover {
      background-color: #d3131a;
      color: #fff;
    }

    .research {
      width: 360px;
      height: 262px;
      border-radius: 0px 0px 4px 4px;
      border: 6px solid #dddddd;

      .classification-content-div {
        border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
        height: 35px;
        line-height: 35px;
        margin-top: -1px;

        i {
          margin-left: 5px;
        }

        span {
          margin-right: 5px;
        }
      }

      .classification-content-div:last-child {
        border-bottom: none;
      }
    }
  }

  li:nth-child(3n + 0) {
    margin-right: 0;
  }
}

.about {
  width: 970px;
  height: 154px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
  margin-bottom: 40px;
  padding: 40px 190px 30px 40px;

  .left {
    display: inline-block;
    vertical-align: top;

    .title {
      width: 654px;
      border-bottom: 2px solid #ccc;
      padding-bottom: 5px;

      em {
        width: 4px;
        height: 19px;
        background: #d3131a;
        font-style: normal;
        display: inline-block;
        margin-right: 9px;
        vertical-align: middle;
      }

      span {
        font-size: 20px;
        font-weight: 500;
        vertical-align: middle;
        margin-left: 1px;
        color: #222222;
      }
    }

    .content {
      margin-top: 23px;
      width: 600px;
    }
  }

  .right {
    display: inline-block;
    margin-left: 196px;

    img {
      width: 120px;
    }

    p {
      text-align: center;
    }
  }
}

.footer {
  width: 100%;
  height: 412px;
  background-color: #403a3a;
  padding-top: 36px;

  .link {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 35px;

    span {
      width: 80px;
      height: 22px;
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;
      line-height: 22px;
    }

    em {
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      line-height: 20px;
      display: inline-block;
      margin-left: 64px;
      font-style: normal;
      cursor: pointer;
    }
  }

  .footer-content {
    height: 200px;
    padding: 35px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.8);

    .container {
      width: 1200px;
      margin: 0 auto;

      ul {
        li {
          width: 180px;
          display: inline-block;
          vertical-align: top;
          margin-right: 75px;

          p {
            font-size: 16px;
            font-weight: 600;
            color: #e0e0e0;
            margin-bottom: 20px;
          }

          span {
            display: inline-block;
            margin-bottom: 10px;
            width: 180px;
            font-size: 14px;
          }

          em {
            font-style: normal;
            font-size: 21px;
            display: inline-block;
            margin-bottom: 17px;
          }
        }
      }
    }
  }

  .end {
    color: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    text-align: center;
    padding-top: 23px;
  }
}
</style>
